import Ax from './axios';

export default class CachedRequest {
  constructor() {
    this.cache = {};
  }

  post(api) {
    if (!this.cache[api]) {
      this.cache[api] = Ax.post(api, {});
    }
    return this.cache[api].catch((ex) => {
      this.cache[api] = null;
      throw ex;
    });
  }

  get(api) {
    if (!this.cache[api]) {
      this.cache[api] = Ax.get(api, {});
    }
    return this.cache[api].catch((ex) => {
      this.cache[api] = null;
      throw ex;
    });
  }

  /**
   * 针对api进行缓存刷新
   * @param {*} api
   */
  refresh(api) {
    this.cache[api] = null;
    return this.post(api);
  }
}
